import { userDetailTypes } from '../actionTypes';

const initialState = {
  data: 'FirstData',
  accountNo: '',
  stateName: []
};

export default (state = { ...initialState }, { type, payload }) => {
  switch (type) {
    case userDetailTypes.UPDATE_PROFILE_DETAIL:
      return {
        ...state,
        data: payload
      };
    case userDetailTypes.GET_ACCOUNT_NUMBER:
      return {
        ...state,
        accountNo: payload
      };
    case userDetailTypes.GET_STATE_NAME:
      return {
        ...state,
        stateName: payload
      };
    default:
      return state;
  }
};
